<div class="bg-white p-4">
  <div class="grid grid-cols-2 gap-4">
    <div class="col-span-1 flex flex-col">
      <button color="primary" mat-button class="w-full text-xl">
        INDIVIDUAL TAX FILING
      </button>
      <mat-divider></mat-divider>

      <br />
      <mat-list>
        @for (item of individualNavItems; track $index) {
        <mat-list-item
          matRipple
          class="nav-item"
          (click)="item.active = true; setActiveNavItem($index)"
          [routerLink]="item.id"
          [lines]="item.lines"
        >
          <mat-icon class="nav-item__icon" color="primary" matListItemAvatar>{{
            item.icon
          }}</mat-icon>
          <span matListItemTitle>{{ item.name }}</span>
          {{ item.secondaryText }}
        </mat-list-item>
        }
      </mat-list>
    </div>
    <div class="col-span-1 flex flex-col">
      <button color="primary" mat-button class="w-full text-xl">
        BUSINESS / PROFESSIONALS
      </button>
      <mat-divider></mat-divider>
      <br />
      <mat-list>
        @for (item of businessNavItems; track $index) {
        <mat-list-item
          matRipple
          class="nav-item"
          (click)="item.active = true; setActiveNavItem($index)"
          [routerLink]="item.id"
          [lines]="item.lines"
        >
          <mat-icon class="nav-item__icon" color="primary" matListItemAvatar>{{
            item.icon
          }}</mat-icon>
          <span matListItemTitle>{{ item.name }}</span>
          {{ item.secondaryText }}
        </mat-list-item>
        }
      </mat-list>
    </div>
  </div>
</div>
